import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetCase } from '../../../hooks/useGetCase';
import Loading from '../../common/Loading';
import {
  Button,
  ButtonsContainer,
  CaseContainer,
  Content,
  GamesTitle,
  Line,
  MenuContainer,
  TagsContainer,
  Title,
} from './styles';
import parse from 'html-react-parser';
import Icon from '../../assets/icons';
import { notification, Breadcrumb, Tag } from 'antd';
import { theme } from '../../../global';
import CaseLinks from '../../CaseLinks';

type TCasePage = {
  menuTitle: string;
  menuHref: string;
};

const CasePage = ({ menuHref, menuTitle }: TCasePage) => {
  const params = useParams();
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification({
    getContainer: () => document.getElementById('main') as HTMLElement,
  });

  const caseId = params.id;

  const { isError, data, isLoading } = useGetCase(caseId);

  const copyToClip = async () => {
    await navigator.clipboard.writeText(window.location.href);
    api.open({
      message: 'Link copied',
      placement: 'top',
      icon: <Icon variant='copy' />,
      style: {
        border: `0.94px solid ${theme.colors.greenLight}`,
        padding: `${theme.spacings.s16}`,
        gap: `${theme.spacings.s16}`,
        borderRadius: `${theme.spacings.s8}`,
        width: '187px',
        height: '52px',
        background: '#A1BF9E0A',
      },
    });
  };

  if (isLoading) return <Loading />;

  if (isError || !data) return <>Error</>;

  const menuLinks = [
    {
      title: menuTitle,
      href: menuHref,
    },
    {
      title: data.title,
    },
  ];

  if (menuTitle !== 'All cases') {
    menuLinks.unshift({
      title: 'All cases',
      href: '/',
    });
  }

  return (
    <CaseContainer>
      <ButtonsContainer>
        <Button onClick={() => navigate(-1)}>
          <Icon variant='arrowLeft' />
        </Button>
        {contextHolder}
        <Button onClick={copyToClip}>
          <Icon variant='share' />
        </Button>
      </ButtonsContainer>
      <MenuContainer>
        <Breadcrumb
          separator={<Icon variant='arrowRight' />}
          items={menuLinks}
        />
      </MenuContainer>
      <Title>{data.title}</Title>
      <Content>{data.content && parse(data.content)}</Content>
      <CaseLinks author={data.author} editor={data.editor} games={0} />
      <TagsContainer>
        {data.tag_names.map((tag) => (
          <Tag key={tag}>{tag}</Tag>
        ))}
      </TagsContainer>
      <Line />
      {/* <GamesTitle>Games</GamesTitle> */}
    </CaseContainer>
  );
};

export default CasePage;
